import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WsService } from '../../services/ws/ws.service';
import { ToastrService } from 'ngx-toastr';
import { IWsPlanningUserBooking } from '../../services/ws/ws.typings';
import { ITask } from '../planning/planning.component';
import { ArrayToDictionaryBy } from '../../utils/array-to-dictionary';
import { DataService } from '../../services/data.service';

@Component({
     selector: 'app-active-booking-list-component',
     templateUrl: 'active-booking-list.component.html',
     styleUrls: ['active-booking-list.component.scss'],
})
export class ActiveBookingListComponent implements OnInit {
     activeBookings: IWsPlanningUserBooking[];
     taskInfo: { [key: number]: ITask };

     constructor(
          private dialogRef: MatDialogRef<any>,
          private ws: WsService,
          private toastrService: ToastrService,
          private dataService: DataService,
          @Inject(MAT_DIALOG_DATA)
          public data: {
               activeBookings: IWsPlanningUserBooking[];
               tasks: ITask[];
          }
     ) {
          this.activeBookings = data.activeBookings;
          this.taskInfo = ArrayToDictionaryBy(data.tasks, 'id');
     }

     ngOnInit() {}

     closeDialog() {
          this.dialogRef.close();
     }

     async cancelBooking(booking: IWsPlanningUserBooking) {
          try {
               await this.ws.planning.cancelBooking(booking.id);
               let index = this.activeBookings.indexOf(booking);
               if (index >= 0) {
                    this.activeBookings.splice(index, 1);
                    this.dataService.userBooking$ = this.activeBookings as any;
                    this.toastrService.show(
                         window.appLang[3188] // Annulation effectué
                    );
               }
          } catch (err) {
               this.toastrService.error();
          }
     }

     async confirmBooking(booking: IWsPlanningUserBooking) {
          try {
               await this.ws.planning.confirmBooking(booking.id);
               this.toastrService.show(window.appLang.RESERVATION_CONFIRMED);
          } catch (err) {
               this.toastrService.error(window.appLang.GENERIC_ERROR_MSG);
          }
     }
}
